import Dialog from "@rio-cloud/rio-uikit/Dialog";
import { useT } from "@hooks";

export interface ConfirmDeleteDialogProps {
  show: boolean;
  title: string;
  message: string;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmDeleteDialog = ({ show, title, message, onClose, onConfirm }: ConfirmDeleteDialogProps) => {
  const t = useT();

  return (
    <Dialog
      show={show}
      title={<span className="text-medium text-size-16">{title}</span>}
      body={
        <div className="padding-20">
          <p>{message}</p>
          <p className="text-color-danger">{t("common.dialog.irreversibleAction")}</p>
        </div>
      }
      footer={
        <div className="display-flex flex-wrap gap-10 justify-content-end">
          <button className="btn btn-default width-100pct-xs" onClick={onClose}>
            {t("common.action.cancel")}
          </button>
          <button className="btn btn-danger width-100pct-xs" onClick={onConfirm}>
            {t("common.action.delete")}
          </button>
        </div>
      }
      onClose={onClose}
      className="exampleDialog"
      showCloseButton
      bsSize="sm"
    />
  );
};

export default ConfirmDeleteDialog;
